module.exports = __webpack_public_path__ + "img/portage-outaouais.64c32ef0.webp";